module.exports = "https://web-assets.ifttt.com/packs/media/header/IFTTT_platform_wordmark_white-345622ec.svg";